import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.154 6h-.533a2.8 2.8 0 0 0-.347-.847l.374-.373a.667.667 0 0 0-.94-.94l-.374.373a2.8 2.8 0 0 0-.846-.346v-.534a.667.667 0 1 0-1.334 0v.534a2.7 2.7 0 0 0-.84.346l-.38-.373a.667.667 0 0 0-.94.94l.374.38c-.06.1-.107.213-.16.32a4 4 0 0 0-1.054-.147 4 4 0 0 0-3.96 3.42 2.333 2.333 0 0 0 .627 4.58h6.113a2.887 2.887 0 0 0 2.887-2.886c0-.354-.069-.705-.2-1.034l.087.08a.667.667 0 0 0 1.133-.47.67.67 0 0 0-.193-.47l-.374-.373c.16-.262.278-.548.347-.847h.533a.667.667 0 1 0 0-1.333m-4.22 6H3.821a1 1 0 0 1 0-2 .667.667 0 0 0 .667-.667 2.667 2.667 0 0 1 5.186-.86.67.67 0 0 0 .52.447 1.554 1.554 0 0 1-.26 3.08m2-4.233q-.177.166-.4.266a3 3 0 0 0-.713-.34 4.1 4.1 0 0 0-1.393-1.66 1.5 1.5 0 0 1 .306-.46 1.613 1.613 0 0 1 2.194 0 1.58 1.58 0 0 1 0 2.2z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })